import ControllerFispq from './ControllerFispq'

export default ControllerFispq


// WEBPACK FOOTER //
// ./src/containers/ControllerFispq/index.js